export default function MultiDomainLogin() {
  this.makeCall = async (item, action) => {
    const response = await fetch(item.endpoint, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token: item.token,
        action,
      }),
    });

    const result = await response.json();
    if (!result.success) {
      throw new Error('Invalid response status');
    }
  };

  const loginToEndpoint = async (item) => {
    try {
      const result = await this.makeCall(item, 'login');
      return result.success;
    } catch (e) {
      return false;
    }
  };

  this.login = async (loginEndpoints) => Promise.all(loginEndpoints.map(loginToEndpoint));
}
